import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useIsMobile } from '@common/utils/hooks';

type MeijiTopLinkProps = {
  label: string;
};

function MeijiTopLink({ label }: MeijiTopLinkProps) {
  return (
    <Link
      component={RouterLink}
      to="/"
      sx={{
        alignItems: 'center',
        color: '#000',
        display: 'inline-flex',
        fontSize: '18px',
        fontWeight: 'bolder',
        textDecoration: 'none',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: '#e30200',
          borderRadius: '50%',
          display: 'flex',
          flexShrink: 0,
          height: 22,
          justifyContent: 'center',
          marginRight: 1,
          width: 22,
        }}
      >
        <ChevronRightIcon sx={{ color: '#fff', fontSize: 26 }} />
      </Box>
      <strong>{label}</strong>
    </Link>
  );
}

function HeadingDivider() {
  return (
    <Box>
      <Box
        sx={{
          borderTop: '5px dotted #c0bcb1',
          my: 5,
          width: '100%',
        }}
      />
    </Box>
  );
}

export function NotFound() {
  const isMobile = useIsMobile();

  const headingFontSize = isMobile ? '16px' : '32px';
  const bodyFontSize = isMobile ? '13px' : '16px';

  return (
    <Box
      sx={{
        mx: isMobile ? 2 : 0,
        px: isMobile ? 0 : '10vw',
        py: 8,
      }}
    >
      <Stack spacing={isMobile ? 6 : 8}>
        <Stack spacing={7}>
          <Typography
            sx={{
              fontSize: headingFontSize,
              fontWeight: 'bold',
            }}
          >
            ご指定のページがみつかりません
          </Typography>

          <Stack spacing={0}>
            <Typography
              component="p"
              sx={{
                color: 'text.secondary',
                fontSize: bodyFontSize,
                m: 0,
              }}
            >
              指定したURLが間違っているか、お探しのページが削除された可能性があります。
            </Typography>

            <Typography
              component="p"
              sx={{
                color: 'text.secondary',
                fontSize: bodyFontSize,
                m: 0,
              }}
            >
              お手数ですが、明治トップから目的のページへアクセスしてくださいますよう、お願いいたします。
            </Typography>
          </Stack>

          <Box sx={{ pt: 1 }}>
            <MeijiTopLink label="明治トップ" />
          </Box>

          <Typography
            component="p"
            sx={{
              color: 'text.secondary',
              fontSize: bodyFontSize,
              m: 0,
              pt: 1,
            }}
          >
            また、検索キーワードを入力し目的のページをお探しいただけます。
          </Typography>
        </Stack>

        <HeadingDivider />

        <Stack spacing={7}>
          <Typography
            sx={{
              fontSize: headingFontSize,
              fontWeight: 'bold',
            }}
          >
            Your page could not be found.
          </Typography>

          <Stack spacing={0}>
            <Typography
              component="p"
              sx={{
                color: 'text.secondary',
                fontSize: bodyFontSize,
                m: 0,
              }}
            >
              There is a possibility that your URL is wrong or this page no
              longer exists.
            </Typography>

            <Typography
              component="p"
              sx={{
                color: 'text.secondary',
                fontSize: bodyFontSize,
                m: 0,
              }}
            >
              Please kindly try re-accessing through Meiji TOP.
            </Typography>
          </Stack>

          <Box sx={{ pt: 1 }}>
            <MeijiTopLink label="Meiji TOP" />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
}
